<div class="breadcrumbGlobal">
    <a [routerLink]="['/mydashboard']">
        <mat-icon>home</mat-icon>
    </a>
    <mat-icon>chevron_right</mat-icon>
    <a [routerLink]="['/mago-university/mago-university']">
        <span translate>MENU.UNIVERSITY</span>
    </a>
    <mat-icon>chevron_right</mat-icon>
    <span translate>Richiedi corso</span>
</div>

<tb-header specificTitle="Ricerca release notes e bugs repo" parentPage="productsviewer"></tb-header>
<div class="contentGlobal">
    <mat-card class="fuse-card-xlarge form-card">
        <mat-card-header>
            <mat-card-title translate style="margin-bottom: 1.4rem">Ricerca release notes e bugs reprt</mat-card-title>
        </mat-card-header>

        <mat-card-content>
            <form #searchReqForm="ngForm">
                <mat-form-field appearance="outline">
                    <mat-label translate>Famiglia prodotto</mat-label>
                    <mat-select
                        required
                        #productFamily="ngModel"
                        [(ngModel)]="request.ProductFamily"
                        name="ProductFamily"
                        (selectionChange)="setReleases()"
                    >
                        <!-- Get family codes -->
                        <mat-option value="MAGO4">Mago4</mat-option>
                        <mat-option value="MCLOUD">MagoCloud</mat-option>
                        <mat-option value="MAGO.NET">Mago.Net</mat-option>
                        <mat-option value="MAGOWEB">MagoWeb</mat-option>
                    </mat-select>
                    <mat-hint *ngIf="!productFamily.valid && productFamily.touched">
                        <span class="mandatory" translate>USER_FORM.ERROR_REQUIRED</span>
                    </mat-hint>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label translate>Release</mat-label>
                    <mat-select
                        required
                        #productRelease="ngModel"
                        [(ngModel)]="request.ProductRelease"
                        name="ProductRelease"
                        [disabled]="!request.ProductFamily"
                    >
                        <mat-option *ngFor="let releaseNr of releases" [value]="releaseNr">{{ releaseNr }}</mat-option>
                    </mat-select>
                    <mat-hint *ngIf="!productRelease.valid && productRelease.touched">
                        <span class="mandatory" translate>USER_FORM.ERROR_REQUIRED</span>
                    </mat-hint>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label translate>Lista</mat-label>
                    <mat-select
                        required
                        #listType="ngModel"
                        [(ngModel)]="request.ListType"
                        name="ListType"
                        [disabled]="!request.ProductRelease"
                        (selectionChange)="setFunctionalAreas($event)"
                    >
                        <mat-option [value]="0">Bug</mat-option>
                        <mat-option [value]="1">Release</mat-option>
                    </mat-select>
                    <mat-hint *ngIf="!listType.valid && listType.touched">
                        <span class="mandatory" translate>USER_FORM.ERROR_REQUIRED</span>
                    </mat-hint>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label translate>Area di riferimento</mat-label>
                    <mat-select
                        required
                        #functionalArea="ngModel"
                        [(ngModel)]="request.FunctionalArea"
                        name="FunctionalArea"
                        [disabled]="isFunctionalAreaInputDisabled()"
                    >
                        <mat-option *ngFor="let functionalArea of functionalAreas" [value]="functionalArea">{{
                            functionalArea
                        }}</mat-option>
                    </mat-select>
                    <mat-hint *ngIf="!functionalArea.valid && functionalArea.touched">
                        <span class="mandatory" translate>USER_FORM.ERROR_REQUIRED</span>
                    </mat-hint>
                </mat-form-field>
            </form>
        </mat-card-content>

        <mat-card-actions>
            <div class="divCardActionRow">
                <button mat-flat-button color="primary" [disabled]="searchReqForm.invalid">
                    <span translate>Cerca</span>
                </button>
            </div>
        </mat-card-actions>
    </mat-card>
</div>
<div *ngIf="isLoading">
    <tb-loading></tb-loading>
</div>
